import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAtom } from 'jotai';

import {
  useMainFilter,
  useSecondFilter,
  useExperienceFilter,
  useCurrencyFilter,
  useSalaryFilter,
  useCountryFilter
} from '../../data/GlobalStates';

const FiltersUrlSync = () => {
  const history = useHistory();
  const location = useLocation();
  const didInit = useRef(false);

  const [MainFilter, setMainFilter] = useAtom(useMainFilter);
  const [SecondFilter, setSecondFilter] = useAtom(useSecondFilter);
  const [ExperienceFilter, setExperienceFilter] = useAtom(useExperienceFilter);
  const [CurrencyFilter, setCurrencyFilter] = useAtom(useCurrencyFilter);
  const [SalaryFilter, setSalaryFilter] = useAtom(useSalaryFilter);
  const [CountryFilter, setCountryFilter] = useAtom(useCountryFilter);

  const isFiltersPage = location.pathname.startsWith('/Filtry');
  const isHomePage = location.pathname === '/';

  // ==========================================
  // URL → STATE (tylko /Filtry)
  // ==========================================
  useEffect(() => {
    if (!isFiltersPage) return;

    const params = new URLSearchParams(location.search);

    setMainFilter(params.get('main') || '');
    setSecondFilter(params.get('second') || '');
    setCountryFilter(params.get('country') || '');
    setExperienceFilter(params.get('experience') || '');
    setCurrencyFilter(params.get('currency') || '');
    setSalaryFilter(params.get('salary') || '');

    didInit.current = true;
  }, [isFiltersPage]);

  // ==========================================
  // STATE → URL (tylko "/" i "/Filtry")
  // ==========================================
  useEffect(() => {
    // 🔥 jeśli jesteśmy gdzie indziej (np. /Oferty/...)
    if (!isFiltersPage && !isHomePage) return;

    // jeśli jesteśmy na "/" i jeszcze nie było inicjalizacji
    if (!didInit.current) {
      didInit.current = true;
    }

    const hasValue =
      MainFilter ||
      SecondFilter ||
      CountryFilter ||
      ExperienceFilter ||
      CurrencyFilter ||
      SalaryFilter;

    // jeśli wszystko puste → wróć na "/"
    if (!hasValue) {
      if (!isHomePage) {
        history.replace('/');
      }
      return;
    }

    const params = new URLSearchParams();

    if (MainFilter) params.set('main', MainFilter);
    if (SecondFilter) params.set('second', SecondFilter);
    if (CountryFilter) params.set('country', CountryFilter);
    if (ExperienceFilter) params.set('experience', ExperienceFilter);
    if (CurrencyFilter) params.set('currency', CurrencyFilter);
    if (SalaryFilter) params.set('salary', SalaryFilter);

    const newSearch = params.toString();

    history.replace({
      pathname: '/Filtry/',
      search: newSearch
    });

  }, [
    MainFilter,
    SecondFilter,
    CountryFilter,
    ExperienceFilter,
    CurrencyFilter,
    SalaryFilter,
    isFiltersPage,
    isHomePage
  ]);

  return null;
};

export default FiltersUrlSync;